import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Portuguese() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Portugal') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    // Customer details
    const [companyName, setCompanyName] = useState();
    const [address, setAddress] = useState();
    const [postalCode, setPostalCode] = useState();
    const [cityLocality, setCityLocality] = useState();
    const [tax, setTax] = useState();
    const [portability, setPortability] = useState();
    const [contactName, setContactName] = useState();
    const [contactNumber, setContactNumber] = useState();
    const [email, setEmail] = useState();

    // Porting Details
    const [donorOperator, setDonorOperator] = useState();
    const [date, setDate] = useState()
    const [portingTime, setPortingTime] = useState()

    // Function to get today's date in "YYYY-MM-DD" format
    const getFormattedDate = (date) => {
        return date.toISOString().split("T")[0];
    };

    // Get today's date and calculate the minimum selectable date (14 days ahead)
    const today = new Date();
    const minDate = new Date();
    minDate.setDate(today.getDate() + 14); // Add 14 days

    // Handle date change
    const handleChangeDate = (e) => {
        const selectedDate = new Date(e.target.value);
        const day = selectedDate.getDay(); // 0 = Sunday, 6 = Saturday

        // Block weekends (Saturday and Sunday)
        if (day === 0 || day === 6) {
            toast.error("Fins de semana não são permitidos. Por favor, selecione um dia útil.");
            setDate(""); // Reset the date field
        } else {
            setDate(e.target.value);
        }
    };

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {

        //customer

        document.querySelector('#companyName').value = form?.country?.customer?.companyName ?? '';
        document.querySelector('#address').value = form?.country?.customer?.address ?? '';
        document.querySelector('#postalCode').value = form?.country?.customer?.postalCode ?? '';
        document.querySelector('#cityLocality').value = form?.country?.customer?.cityLocality ?? '';
        document.querySelector('#tax').value = form?.country?.customer?.tax ?? '';
        document.querySelector('#portability').value = form?.country?.customer?.portability ?? '';
        document.querySelector('#contactName').value = form?.country?.customer?.contactName ?? '';
        document.querySelector('#contactNumber').value = form?.country?.customer?.contactNumber ?? '';
        document.querySelector('#email').value = form?.country?.customer?.email ?? '';
        setCompanyName(form?.country?.customer?.companyName ?? '');
        setAddress(form?.country?.customer?.address ?? '');
        setPostalCode(form?.country?.customer?.postalCode ?? '');
        setCityLocality(form?.country?.customer?.cityLocality ?? '');
        setTax(form?.country?.customer?.tax ?? '');
        setPortability(form?.country?.customer?.portability ?? '');
        setContactName(form?.country?.customer?.contactName ?? '');
        setContactNumber(form?.country?.customer?.contactNumber ?? '');
        setEmail(form?.country?.customer?.email ?? '');

        // Porting Details

        setTableDataSingle(form?.country?.portingDetails?.Single_Number ?? []);
        setTableDataRange(form?.country?.portingDetails?.Number_Range ?? []);

        document.querySelector('#donorOperator').value = form?.country?.portingDetails?.donorOperator ?? '';
        document.querySelector('#date').value = form?.country?.portingDetails?.date ?? '';
        document.querySelector('#portingTime').value = form?.country?.portingDetails?.portingTime ?? '';
        setDonorOperator(form?.country?.portingDetails?.donorOperator ?? '');
        setDate(form?.country?.portingDetails?.date ?? '');
        setPortingTime(form?.country?.portingDetails?.portingTime ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart (9 digits)
                if (startValue !== '' && !/^\d{9}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop (9 digits)
                if (endValue !== '' && !/^\d{9}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                // if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                //     setValidationStates(prev => ({
                //         ...prev,
                //         [`startNumber-${row.id}`]: false,
                //         [`endNumber-${row.id}`]: false,
                //     }));
                // }

            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Portugal",
            "customer": {
                "companyName": companyName || "",
                "address": address || "",
                "postalCode": postalCode || "",
                "cityLocality": cityLocality || "",
                "tax": tax || "",
                "portability": portability || "",
                "contactName": contactName || "",
                "contactNumber": contactNumber || "",
                "email": email || ""
            },
            "portingDetails": {
                "Single_Number": tableDataSingle,
                "Number_Range": tableDataRange,
                "donorOperator": donorOperator || "",
                "date": date || "",
                "portingTime": portingTime || ""
            }

        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        //customer

        if (!companyName) {
            validationErrors.companyName = 'Please fill in Company Name';
        }
        if (!tax) {
            validationErrors.tax = 'Please fill in Tax Number';
        }
        if (!portability) {
            validationErrors.portability = 'please fill in Portability validation code number';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = companyName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                {/* customer */}
                <Container>

                    <h2 className='heading'>DADOS DO CLIENTE</h2>

                    <b>Os campos obrigatórios são marcados com *</b> <br></br> <br></br>

                    <p>Os dados do cliente devem ser os mesmos que constam no operador detentor do(s) números(s) a portar.</p>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nome empresa*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^.*$/)}

                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Digite o nome da empresa
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Morada</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox`}

                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Digite o endereço
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('postalCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Código Postal</label> <br />
                            <input
                                onChange={(e) => setPostalCode(e.target.value)}
                                type="text"
                                id="postalCode"
                                placeholder=""
                                className={`inputbox`}

                            />
                            {hoveredField === 'postalCode' && (
                                <div className="hover-description">
                                    Digite o código postal
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('cityLocality')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Localidade</label> <br />
                            <input
                                onChange={(e) => setCityLocality(e.target.value)}
                                type="text"
                                id="cityLocality"
                                placeholder=""
                                className={`inputbox`}

                            />
                            {hoveredField === 'cityLocality' && (
                                <div className="hover-description">
                                    Digite a cidade/localidade
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('tax')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contribuinte(NIF)*</label> <br />
                            <input
                                onChange={(e) => setTax(e.target.value)}
                                type="text"
                                id="tax"
                                placeholder=""
                                className={`inputbox ${validationStates.tax === false ? 'error' : ''}`}
                                onBlur={() => validateInput('tax', /^[a-zA-Z0-9]+$/)}

                            />
                            {hoveredField === 'tax' && (
                                <div className="hover-description">
                                    Digite o número de identificação fiscal
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('portability')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Código Validação Portabilidade (CVP)*</label> <br />
                            <input
                                onChange={(e) => setPortability(e.target.value)}
                                type="text"
                                id="portability"
                                placeholder=""
                                className={`inputbox ${validationStates.portability === false ? 'error' : ''}`}
                                onBlur={() => validateInput('portability', /^[a-zA-Z0-9]{12}$/)}

                            />
                            {hoveredField === 'portability' && (
                                <div className="hover-description">
                                    Digite o código de validação de portabilidade - você pode encontrá-lo na fatura do provedor anterior (deve ter 12 dígitos)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nome contato</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id="contactName"
                                placeholder=""
                                className={`inputbox`}

                            />
                            {hoveredField === 'contactName' && (
                                <div className="hover-description">
                                    Digite o nome do contato
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nº Telefone contato</label> <br />
                            <input
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text"
                                id="contactNumber"
                                placeholder=""
                                className={`inputbox ${contactNumber && !/^\d+$/.test(contactNumber) ? 'error' : ''}`}
                                onBlur={() => {
                                    if (contactNumber && !/^\d+$/.test(contactNumber)) {
                                        setValidationStates((prev) => ({ ...prev, contactNumber: false }));
                                    } else {
                                        setValidationStates((prev) => ({ ...prev, contactNumber: true }));
                                    }
                                }}
                            />
                            {hoveredField === 'contactNumber' && (
                                <div className="hover-description">
                                    Digite o número de telefone do contato
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email</label> <br />
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id="email"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Digite o endereço de e-mail
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                {/* porting details */}

                <Container>
                    <h2 className='heading'>DADOS DE PORTABILIDADE</h2> <br></br>

                    <h4 className='text-decoration-underline'>Números Individuais de Telefone</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Numero</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for9 digits only when not empty
                                                if (value !== '' && !/^\d{9}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits only when not empty
                                                if (row.num !== '' && !/^\d{9}$/.test(row.num)) {
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                Adicione os números individuais, se houver
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                O número deve ter 9 dígitos
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br></br><br></br> <br />

                    <h4 className='text-decoration-underline'>Sequência de Números Telefone</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Carregar arquivo
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col xs={5}>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Baixar modelo de intervalo de numeração
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remover
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Arquivo carregado: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>O modelo é o mesmo usado para a solicitação de portabilidade do btd.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Início do intervalo numérico</th>
                                <th>Fim do intervalo numérico</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`} // Corrected ID for num input
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                // Immediate validation feedback for 9 digits
                                                if (value && !/^\d{9}$/.test(value)) { // Allow 9 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits
                                                if (row.sNumber && !/^\d{9}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Digite o início do intervalo de números
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && row.sNumber !== '' && (
                                            <div className="error-message">
                                                O número deve ter 9 dígitos
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`} // Corrected ID for num input
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                // Immediate validation feedback for 9 digits
                                                if (value && !/^\d{9}$/.test(value)) { // Allow 9 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9 digits
                                                if (row.eNumber && !/^\d{9}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be 9 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Digite o fim do intervalo de números
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && row.eNumber !== '' && (
                                            <div className="error-message">
                                                O número deve ter 9 dígitos
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br> <br />

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('donorOperator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operador doador</label> <br />
                            <input
                                onChange={(e) => setDonorOperator(e.target.value)}
                                type="text"
                                id="donorOperator"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'donorOperator' && (
                                <div className="hover-description">
                                    Digite o nome do operador doador
                                </div>
                            )}
                        </Col>
                        <Col>
                            <label>Data Portação</label> <br />
                            <input
                                onChange={handleChangeDate}
                                type="date"
                                id="date"
                                value={date}
                                className="inputbox no-weekends"
                                min={getFormattedDate(minDate)} // Disable dates before this
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Digite a data de portabilidade (você pode escolher apenas dias da semana)
                                </div>
                            )}
                        </Col>
                        <Col
                            onMouseEnter={() => handleMouseEnter('portingTime')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Hora</label> <br />
                            <select
                                id="portingTime"
                                onChange={(e) => setPortingTime(e.target.value)}
                                className={`inputbox`}
                            >
                                <option value=""></option>
                                <option value="09:30 (08:00-11:00)">09:30 (08:00-11:00)</option>
                                <option value="13:30 (12:00-15:00)">13:30 (12:00-15:00)</option>
                                <option value="17:30 (16:00-19:00)">17:30 (16:00-19:00)</option>
                                <option value="21:30 (20:00-23:00)">21:30 (20:00-23:00)</option>
                            </select>
                            {hoveredField === 'portingTime' && (
                                <div className="hover-description">
                                    Este intervalo de tempo está em horário local
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <p>Vem pelo presente denunciar o actual contracto em vigor, para efeitos de Portabilidade, relativamente à(s) linha(s) telefónica(s) supra mencionada(s). A Denúncia do Contrato considera-se efectiva no momento em que a Portabilidade estiver concluída.</p>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Portuguese;